import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { Playbook, PlaybookStep } from "../../playbook/model/Playbook";

export const useCreateSystemPlaybook = () => {
  const {
    data: createdPlaybook,
    call,
    isLoading: isCreating,
    isFailed: isCreateFailed,
  } = useApiPrivateRequest<Playbook>((response) => new Playbook(response));

  const createPlaybook = async (
    title: string,
    description: string,
    steps: PlaybookStep[],
  ) => {
    await call(`/admin/playbooks`, "POST", undefined, {
      title,
      description,
      steps,
    });
  };

  return {
    createdPlaybook,
    createPlaybook,
    isCreating,
    isCreateFailed,
  };
};
